<template>
  <div class="cost_price_enquiry">
    <!--成本价查询头部-->
    <div class="cost_price_enquiry_top">
      <div class="first_line">
        <div>
          <el-select v-model.trim="selectChannelValue" placeholder="渠道">
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="wper13">
          <el-select v-model.trim="selectBrandType" placeholder="品牌">
            <el-option
              v-for="item in brandTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div><input type="text" v-model.trim="numOrName" title="货号/品名" placeholder="货号/品名"></div>
       <!-- <div class="w32">折扣:</div>
        <div class="w70">
          <el-select v-model.trim="selectSymbolType" placeholder="请选择">
            <el-option
              v-for="item in symbolType"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="wper9"><input type="text" v-model.trim="discount" @blur="floatNum()" title="折扣数值"></div> -->
        <button class="btn_normal w116 mr15" @click="queryData()">查询</button>
        <button class="btn_normal w145" @click="ctrBtn('exportCostPrice')">导出成本价</button>
      </div>
    </div>
    <!--成本价查询信息-->
    <div class="cost_price_enquiry_msg">
      <table class="table">
        <thead>
        <tr>
          <th>渠道</th>
          <th>品牌</th>
          <th>货号</th>
          <th>品名</th>
          <th>零售价</th>
          <th>成本价</th>
          <th>成本折扣</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td>{{item.StoreroomShowName}}</td>
          <td>{{item.BrandName}}</td>
          <td>{{item.GoodsId}}</td>
          <td>{{item.GoodsName}}</td>
          <td>{{item.MarketPrice}}</td>
          <td>{{item.CostPrice}}</td>
          <td>{{item.CostDiscount}}</td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="7">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div v-if="list.length" class="text_right mt20">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <cost-price-enquiry-embed-msg v-if="isShow"
                                  :title="dialogTitle"
                                  :params="params"
                                  :costPriceEnquiryMsg="costPriceEnquiryMsg"
                                  :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></cost-price-enquiry-embed-msg>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import CostPriceEnquiryEmbedMsg from './cost-price-enquiry-embed-msg';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'cost-price-enquiry',
    components: {CostPriceEnquiryEmbedMsg, LoadingDialog},
    data() {
      return {
        list: '', // 成本价列表
        selectChannelValue: '', // 选择的渠道列表
        channelList: [
          {id: '', text: '所有渠道'}
        ], // 渠道下拉列表
        selectBrandType: '', // 品牌下拉
        brandTypeList: [], // 查询品牌下拉列表
        numOrName: '', // 货号/品名
        selectSymbolType: 0, // 选择的符号
        symbolType: [
          {id: 0, text: '符号'},
          {id: 1, text: '='},
          {id: 2, text: '>'},
          {id: 3, text: '>='},
          {id: 4, text: '<'},
          {id: 5, text: '<='}
        ], // 符号类型下拉列表
        discount: '', // 折扣
        params: null, // 导出的传入参数
        costPriceEnquiryMsg: '', // 导出的成本价信息
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 根据渠道 + 品牌 + 货号/品名 + 符号 + 库存 查询
      queryData() {
        this.currentPage = 1;
        this.loadAgentGoodsCostPricePageData();
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannelValue = '';
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 获取品牌下拉框信息
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg) {
            this.brandTypeList = res.data.resData;
            this.brandTypeList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrandType = '';
          } else {
            this.brandTypeList = [];
            this.selectBrandType = res.data.errorMsg;
          }
        });
      },

      // 成本价查询分页数据
      loadAgentGoodsCostPricePageData() {
        this.isLoading = true;
        this.list = [];
        this.params = {
          goodsIdOrName: this.numOrName,
          storeroomId: this.selectChannelValue,
          brandId: this.selectBrandType,
         /* symbol: this.selectSymbolType,
          costdiscount: parseFloat(this.discount), */
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.loadAgentGoodsCostPricePageData, this.params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              }
            }
          }, 500);
          this.list = res.data.resData.DataList;
          this.total = res.data.resData.TotalCounts;
        });
      },

      // 验证正浮点数字
      floatNum() {
        if (this.discount) {
          if (this.discount === '0') {
            this.discount = 0;
          } else if (parseFloat(this.discount)) {
            this.discount = parseFloat(this.discount);
          } else {
            this.discount = null;
          }
        } else {
          this.discount = null;
        }
      },

      // 操作按钮
      ctrBtn(type) {
        this.isShow = true;
        this.dialogShowType = type;
        this.dialogTitle = '提示';

        // 传入参数的判断
        this.params = {
          idOrName: this.numOrName,
          storeroomId: this.selectChannelValue,
          brandId: this.selectBrandType,
          symbol: this.selectSymbolType,
          costdiscount: parseFloat(this.discount),
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAgentGoodsCostPricePageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAgentGoodsCostPricePageData();
      }
    },
    created() {
      this.getAllStoreroomsList();
      this.getAllBrandsList();
      this.loadAgentGoodsCostPricePageData();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.selectChannelValue = '';
        this.selectBrandType = '';
        this.numOrName = '';
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.loadAgentGoodsCostPricePageData();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .cost_price_enquiry {
    .cost_price_enquiry_top {
      padding: 20px 5px 5px;

      .first_line, .second_line {
        height: 45px;
        line-height: 40px;

        &>div {
          display: inline-block;
          width: 15%;
          margin-right: 0.5%;
        }

        .wper8 {
          width: 8%;
        }

        .wper9 {
          width: 9%;
        }

        .wper13 {
          width: 13%;
        }

        .w32 {
          width: 32px;
        }

        .w70 {
          width: 70px;
        }
      }
    }

    .channel_inventory_enquiry_msg {
      /*height: calc(100% - 115px);*/
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/cost-price-enquiry.vue